import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

import { onBeforeMount, Raw, ref } from 'vue'

import ArticlesBlock from '@/app/components/listing/ArticlesBlock.vue'
import NoCurrentlyReadingDocsBlock from '@/app/components/listing/NoCurrentlyReadingDocsBlock.vue'
import EmptyListingBlock from '@/app/components/listing/EmptyListingBlock.vue'

import { filteredDocsByDocType } from '@/models/doc'

import { useWait } from '@/app/composables/useWait'
import { Doc } from '@/models/interfaces'
import LibraryLayout from '@/app/components/library/LibraryLayout.vue'
import { ArticlesView } from '@/models/doc.article'
import { DocSortOption } from '@/models/doc'
import { ListView } from '@/models/docs.list'


export default /*@__PURE__*/_defineComponent({
  __name: 'LibraryArticles',
  props: {
    docs: {}
  },
  setup(__props: any) {

const props = __props

const wait = useWait()

const viewedViewRef = ref<Raw<ListView> | null>(null)
const favoritesViewRef = ref<Raw<ListView> | null>(null)

onBeforeMount(async () => {
  await getArticles()
})

const getArticles = async (): Promise<void> => {
  wait.start('Loading Library')
  try {
    /* TODO: We need to implement offline support for home/docs, #12899.
    
    if (offline.isOffline) {
       await loadBookListFromNativeStorage()
     } */

    const articleData = filteredDocsByDocType(props.docs, 'article')

    const viewed = await ArticlesView.createView(articleData)
    viewed.enableContinueReading()
    viewed.enableActionsButton()
    viewed.setList('viewed')
    viewed.sort(DocSortOption.accessed)
    viewedViewRef.value = new ListView('Viewed', viewed, {
      viewAllLink: '/app/articles/list/viewed',
    })

    const favorites = await ArticlesView.createView(articleData)
    favorites.setIsFavorite(true)
    favoritesViewRef.value = new ListView('Favorites', favorites, {
      viewAllLink: '/app/articles/list/favorites',
    })

    wait.end('Loading Library')
  } catch (error) {
    if (Sentry) {
      Sentry.captureException(error)
    }
    wait.end('Loading Library')
    wait.start('Error Loading Library')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LibraryLayout, null, {
    default: _withCtx(() => [
      (favoritesViewRef.value && favoritesViewRef.value.dataLength)
        ? (_openBlock(), _createBlock(ArticlesBlock, {
            key: 0,
            view: favoritesViewRef.value
          }, null, 8, ["view"]))
        : (_openBlock(), _createBlock(EmptyListingBlock, {
            key: 1,
            title: "Favorites",
            class: "empty-favorite"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", null, [
                _createElementVNode("p", null, "Articles you've marked as a Favorite will appear here."),
                _createElementVNode("p", null, " To mark an article as a Favorite, click the bookmark icon on the article card or while reading the article. ")
              ], -1)
            ]))]),
            _: 1
          })),
      (viewedViewRef.value && viewedViewRef.value.dataLength)
        ? (_openBlock(), _createBlock(ArticlesBlock, {
            key: 2,
            view: viewedViewRef.value
          }, null, 8, ["view"]))
        : (_openBlock(), _createBlock(NoCurrentlyReadingDocsBlock, {
            key: 3,
            title: "Viewed"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("p", null, " Articles you're currently reading will appear here. Find new things to read on the Discover page! ", -1)
            ]))]),
            _: 1
          }))
    ]),
    _: 1
  }))
}
}

})